import Cookies from 'js-cookie';
//Showcontestants
export const fetchFrontSetting = (url, cat_id) => {
    const HASH = Cookies.get('wpvc_voting_authorize');
    let dataURL = url + "wpvc-voting/v1/wpvcgetshowcontestant";
    return dispatch => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorize-wpvc': HASH, 'Authorize-wpvc-request': 'xmlhttprequest' },
            body: JSON.stringify({ id: cat_id })
        };
        let server_time = '';
        return fetch(dataURL, requestOptions)
            .then(res => {
                server_time = res.headers.get("Date");
                return res.json()
            })
            .then(json => {
                //After Data Loading Send to Get Data to display the data respectively
                json['current_date'] = server_time;
                dispatch(getFrontData(json));
                return json;
            });

    };
};

export const fetchallposts = (url, cat_id = null, shortatr, paged = null, load_more = null) => {
    const HASH = Cookies.get('wpvc_voting_authorize');
    let query = null;
    let dataURL = null;

    let search_query = '';
    if (shortatr.search_text != "") {
        search_query = "&search=" + shortatr.search_text;
    }

    if (paged == null)
        query = search_query + "&per_page=" + shortatr.postperpage + "&page=" + shortatr.paged + "&orderby=" + shortatr.orderby + "&order=" + shortatr.order;
    else
        query = search_query + "&per_page=" + shortatr.postperpage + "&page=" + paged + "&orderby=" + shortatr.orderby + "&order=" + shortatr.order;

    if (cat_id == null)
        dataURL = url + "wp/v2/contestants?status=publish" + query;
    else
        dataURL = url + "wp/v2/contestants?contest_category=" + cat_id + "&status=publish" + query;

    let perpage = shortatr.postperpage;
    if (perpage == 0) {
        return dispatch => {
            let emptypost = { posts: 'perpage', pagin_val: '' }
            dispatch(getFrontData(emptypost))
        }
    }
    if (perpage < 0) {
        return dispatch => {
            let emptypost = { posts: 'perpage', pagin_val: '' }
            dispatch(getFrontDataErrors(emptypost, "Please do not use a negative number for the <strong>postperpage</strong> shortcode attribute."));
        }
    }
    if (perpage > 500) {
        return dispatch => {
            let emptypost = { posts: 'perpage', pagin_val: '' }
            dispatch(getFrontDataErrors(emptypost, "Maximum allowed for <strong>postperpage</strong> shortcode attribute is 500."));
        }
    }
    return dispatch => {
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorize-wpvc': HASH, 'Authorize-wpvc-request': 'xmlhttprequest', 'Authorize-wpvc-requestmethod': 'authorprofile' },
        };
        let pagin_total = "";
        let pagin_totalpages = "";
        let server_time = '';
        return fetch(dataURL, requestOptions)
            .then(res => {
                pagin_total = res.headers.get("X-WP-Total");
                pagin_totalpages = res.headers.get('X-WP-TotalPages');
                server_time = res.headers.get("Date");
                return res.json()
            })
            .then(json => {
                //After Data Loading Send to Get Data to display the data respectively
                let paginate_posts = { total_posts: pagin_total, page_nums: pagin_totalpages }
                let post = { posts: json, pagin_val: paginate_posts, current_date: server_time }
                json['current_date'] = server_time;
                if (load_more == 'load') {
                    dispatch(getPostLoad('posts', json));
                }
                else {
                    dispatch(getFrontData(post));
                }
                return json;
            });

    };
};

export const fetchposts = (url, cat_id, shortatr, paged = null, load_more = null, search = "", author = "") => {
    const HASH = Cookies.get('wpvc_voting_authorize');
    let query = null;
    let search_query = '';
    if (search != "") {
        search_query = "&search=" + search;
    }
    let author_query = '';
    if (author != "") {
        author_query = "&author=" + author;
    }

    let exclude = "";
    if (shortatr.exclude !== undefined) {
        exclude = "&exclude=" + shortatr.exclude;
    }

    let include = "";
    if (shortatr.include !== undefined) {
        include = "&include=" + shortatr.include;
    }

    let perpage = shortatr.postperpage;
    if (paged == null)
        query = search_query + author_query + exclude + include + "&per_page=" + shortatr.postperpage + "&page=" + shortatr.paged + "&orderby=" + shortatr.orderby + "&order=" + shortatr.order;
    else
        query = search_query + author_query + exclude + include + "&per_page=" + shortatr.postperpage + "&page=" + paged + "&orderby=" + shortatr.orderby + "&order=" + shortatr.order;

    let dataURL = url + "wp/v2/contestants?contest_category=" + cat_id + "&status=publish" + query;
    if (perpage == 0) {
        return dispatch => {
            let emptypost = { posts: 'perpage', pagin_val: '' }
            dispatch(getFrontData(emptypost))
        }
    }
    if (perpage < 0) {
        return dispatch => {
            let emptypost = { posts: 'perpage', pagin_val: '' }
            dispatch(getFrontDataErrors(emptypost, "Please do not use a negative number for the <strong>postperpage</strong> shortcode attribute."));
        }
    }
    if (perpage > 500) {
        return dispatch => {
            let emptypost = { posts: 'perpage', pagin_val: '' }
            dispatch(getFrontDataErrors(emptypost, "Maximum allowed for <strong>postperpage</strong> shortcode attribute is 500."));
        }
    }
    return dispatch => {
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorize-wpvc': HASH, 'Authorize-wpvc-request': 'xmlhttprequest' },
        };
        let pagin_total = "";
        let pagin_totalpages = "";
        return fetch(dataURL, requestOptions)
            .then(res => {
                pagin_total = res.headers.get("X-WP-Total");
                pagin_totalpages = res.headers.get('X-WP-TotalPages');
                return res.json()
            })
            .then(json => {
                //After Data Loading Send to Get Data to display the data respectively
                let paginate_posts = { total_posts: pagin_total, page_nums: pagin_totalpages }
                let post = { posts: json, pagin_val: paginate_posts }
                if (load_more == 'load') {
                    dispatch(getPostLoad('posts', json));
                }
                else {
                    dispatch(getFrontData(post));
                }
                return json;
            });

    };
};

export const fetchauthorallprofile = (url, shortatr, paged = null, load_more = null) => {
    const HASH = Cookies.get('wpvc_voting_authorize');
    let query = null;
    if (paged == null)
        query = "&author=" + shortatr.user_id_profile + "&per_page=" + shortatr.postperpage + "&page=" + shortatr.paged + "&orderby=date&order=desc";
    else
        query = "&author=" + shortatr.user_id_profile + "&per_page=" + shortatr.postperpage + "&page=" + paged + "&orderby=date&order=desc";

    let dataURL = url + "wp/v2/contestants?status=publish" + query;

    let perpage = shortatr.postperpage;
    if (perpage == 0) {
        return dispatch => {
            let emptypost = { posts: 'perpage', pagin_val: '' }
            dispatch(getFrontData(emptypost))
        }
    }
    if (perpage < 0) {
        return dispatch => {
            let emptypost = { posts: 'perpage', pagin_val: '' }
            dispatch(getFrontDataErrors(emptypost, "Please do not use a negative number for the <strong>postperpage</strong> shortcode attribute."));
        }
    }
    if (perpage > 500) {
        return dispatch => {
            let emptypost = { posts: 'perpage', pagin_val: '' }
            dispatch(getFrontDataErrors(emptypost, "Maximum allowed for <strong>postperpage</strong> shortcode attribute is 500."));
        }
    }
    return dispatch => {
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorize-wpvc': HASH, 'Authorize-wpvc-request': 'xmlhttprequest', 'Authorize-wpvc-requestmethod': 'authorprofile' },
        };
        let pagin_total = "";
        let pagin_totalpages = "";
        return fetch(dataURL, requestOptions)
            .then(res => {
                pagin_total = res.headers.get("X-WP-Total");
                pagin_totalpages = res.headers.get('X-WP-TotalPages');
                return res.json()
            })
            .then(json => {
                //After Data Loading Send to Get Data to display the data respectively
                let paginate_posts = { total_posts: pagin_total, page_nums: pagin_totalpages }
                let post = { posts: json, pagin_val: paginate_posts }
                if (load_more == 'load') {
                    dispatch(getPostLoad('posts', json));
                }
                else {
                    dispatch(getFrontData(post));
                }
                return json;
            });

    };
};

export const fetchauthorprofile = (url, cat_id, shortatr, paged = null, load_more = null) => {
    const HASH = Cookies.get('wpvc_voting_authorize');
    let query = null;
    if (paged == null)
        query = "&author=" + shortatr.user_id_profile + "&per_page=" + shortatr.postperpage + "&page=" + shortatr.paged + "&orderby=date&order=desc";
    else
        query = "&author=" + shortatr.user_id_profile + "&per_page=" + shortatr.postperpage + "&page=" + paged + "&orderby=date&order=desc";

    let dataURL = url + "wp/v2/contestants?contest_category=" + cat_id + "&status=publish" + query;
    let perpage = shortatr.postperpage;
    if (perpage == 0) {
        return dispatch => {
            let emptypost = { posts: 'perpage', pagin_val: '' }
            dispatch(getFrontData(emptypost))
        }
    }
    if (perpage > 500 || perpage < 0) {
        return dispatch => {
            let emptypost = { posts: 'perpage', pagin_val: '' }
            dispatch(getFrontDataErrors(emptypost, "Please check the <strong>postperpage</strong> shortcode attribute !"));
        }
    }
    return dispatch => {
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorize-wpvc': HASH, 'Authorize-wpvc-request': 'xmlhttprequest' },
        };
        let pagin_total = "";
        let pagin_totalpages = "";
        return fetch(dataURL, requestOptions)
            .then(res => {
                pagin_total = res.headers.get("X-WP-Total");
                pagin_totalpages = res.headers.get('X-WP-TotalPages');
                return res.json()
            })
            .then(json => {
                //After Data Loading Send to Get Data to display the data respectively
                let paginate_posts = { total_posts: pagin_total, page_nums: pagin_totalpages }
                let post = { posts: json, pagin_val: paginate_posts }
                if (load_more == 'load') {
                    dispatch(getPostLoad('posts', json));
                }
                else {
                    dispatch(getFrontData(post));
                }
                return json;
            });

    };
};


export const fetchtopten = (url, cat_id, shortatr) => {
    const HASH = Cookies.get('wpvc_voting_authorize');
    let page_count = (shortatr.showcount) ? shortatr.showcount : (shortatr.allcatoption.topten_custom_count || 10);
    let query = "&per_page=" + page_count + "&page=1&orderby=votes_count&order=desc";
    let dataURL = url + "wp/v2/contestants?contest_category=" + cat_id + "&status=publish" + query;
    return dispatch => {
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorize-wpvc': HASH, 'Authorize-wpvc-request': 'xmlhttprequest' },
        };

        return fetch(dataURL, requestOptions)
            .then(res => res.json())
            .then(json => {
                //After Data Loading Send to Get Data to display the data respectively
                let post = { top_contestans: json }
                dispatch(getFrontData(post));
                return json;
            });

    };
};

export const fetchrecentposts = (url, shortatr) => {
    const HASH = Cookies.get('wpvc_voting_authorize');
    let query = "&per_page=" + shortatr.showcount + "&page=1&orderby=" + shortatr.orderby + "&order=" + shortatr.order;
    let dataURL = url + "wp/v2/contestants?status=publish" + query;
    return dispatch => {
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorize-wpvc': HASH, 'Authorize-wpvc-request': 'xmlhttprequest' },
        };

        return fetch(dataURL, requestOptions)
            .then(res => res.json())
            .then(json => {
                //After Data Loading Send to Get Data to display the data respectively
                let post = { posts: json }
                dispatch(getFrontData(post));
                return json;
            });

    };
};

export const deleteContestant = (url, post_id) => {
    const HASH = Cookies.get('wpvc_voting_authorize');
    let dataURL = url + "wpvc-voting/v1/wpvcdeletecontestant";
    return dispatch => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorize-wpvc': HASH, 'Authorize-wpvc-request': 'xmlhttprequest' },
            body: JSON.stringify({ id: post_id })
        };

        return fetch(dataURL, requestOptions)
            .then(res => res.json())
            .then(json => {
                dispatch(getFrontData(json));
                return json;
            });

    };
};

export const fetcheditpost = (url, cat_id, post_id) => {
    const HASH = Cookies.get('wpvc_voting_authorize');
    let dataURL = url + "wpvc-voting/v1/wpvceditcontestant";
    return dispatch => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorize-wpvc': HASH, 'Authorize-wpvc-request': 'xmlhttprequest' },
            body: JSON.stringify({ termid: cat_id, postid: post_id })
        };

        return fetch(dataURL, requestOptions)
            .then(res => res.json())
            .then(json => {
                //After Data Loading Send to Get Data to display the data respectively
                dispatch(SingleData('contestant_form', json));
                return json;
            });

    };
};

//Insert submit entries
export const UpdateContestant = (url, id, insertData) => {
    const HASH = Cookies.get('wpvc_voting_authorize');
    let dataURL = url + "wpvc-voting/v1/wpvcupdatesubmitentry";
    return dispatch => {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify({ insertData: insertData, post_id: id }),
            headers: { 'Content-Type': 'application/json', 'Authorize-wpvc': HASH, 'Authorize-wpvc-request': 'xmlhttprequest' },
        };

        return fetch(dataURL, requestOptions)
            .then(res => res.json())
            .then(json => {
                dispatch(getFrontData(json));
                return json;
            });
    };
};

export const fetchsinglepost = (url, post_id) => {
    const HASH = Cookies.get('wpvc_voting_authorize');
    let dataURL = url + "wp/v2/contestants/" + post_id;
    return dispatch => {
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorize-wpvc': HASH, 'Authorize-wpvc-request': 'xmlhttprequest' },
        };
        let server_time = '';
        return fetch(dataURL, requestOptions)
            .then(res => {
                server_time = res.headers.get("Date");
                return res.json()
            })
            .then(json => {
                //After Data Loading Send to Get Data to display the data respectively
                let singlecontestant = { post_single: json, current_date: server_time }
                dispatch(getFrontData(singlecontestant));
                return json;
            });
    };
};

//Insert submit entries
export const SubmitContestant = (url, id, insertData, userdata = "", post_status = "", coinbaseCharge = "") => {
    const HASH = Cookies.get('wpvc_voting_authorize');
    let dataURL = url + "wpvc-voting/v1/wpvcsubmitentry";
    return dispatch => {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify({ insertData: insertData, category_id: id, userdata: userdata, post_status: post_status, coinbaseCharge: coinbaseCharge }),
            headers: { 'Content-Type': 'application/json', 'Authorize-wpvc': HASH, 'Authorize-wpvc-request': 'xmlhttprequest' },
        };

        return fetch(dataURL, requestOptions)
            .then(res => res.json())
            .then(json => {
                dispatch(getFrontData(json));
                if (coinbaseCharge != "") {
                    dispatch(updateFrontData('payment_entry_open', false));
                }
                return json;
            });
    };
};

//Insert submit entries
export const SubmitFiles = (url, formData) => {
    const HASH = Cookies.get('wpvc_voting_authorize');
    let dataURL = url + "wpvc-voting/v1/wpvcuploadfiles";
    return dispatch => {

        const requestOptions = {
            method: 'POST',
            body: formData,
            headers: { 'Authorize-wpvc': HASH, 'Authorize-wpvc-request': 'xmlhttprequest' },
        };

        return fetch(dataURL, requestOptions)
            .then(res => res.json())
            .then(json => {
                return json;
            });
    };
};

//SendEmail
export const SendEmail = (url, post_id, userdata = "", insertdata = "", gateway = "") => {
    const HASH = Cookies.get('wpvc_voting_authorize');
    let dataURL = url + "wpvc-voting/v1/wpvcsendemail";
    return dispatch => {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify({ post_id: post_id, userdata: userdata, insertdata: insertdata, gateway: gateway }),
            headers: { 'Content-Type': 'application/json', 'Authorize-wpvc': HASH, 'Authorize-wpvc-request': 'xmlhttprequest' },
        };
        return fetch(dataURL, requestOptions)
            .then(res => res.json())
            .then(json => {
                return json;
            });
    };
};

//Insert Payment Information
export const insertPayment = (url, gateway, insertData, amount, currency = '') => {
    const HASH = Cookies.get('wpvc_voting_authorize');
    let dataURL = url + "wpvc-voting/v1/wpvcsavepayment";
    return dispatch => {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify({ gateway: gateway, insertData: insertData, amount: amount, currency: currency }),
            headers: { 'Content-Type': 'application/json', 'Authorize-wpvc': HASH, 'Authorize-wpvc-request': 'xmlhttprequest' },
        };

        return fetch(dataURL, requestOptions)
            .then(res => res.json())
            .then(json => {
                dispatch(updateFrontData('payment_entry_open', false));
                dispatch(updateFrontData('payment_entry_success', 'success'));
                dispatch(updateFrontData('wpvc_current_gateway', json.gateway));
                return json;
            });
    };
};

//Stripe Actions
export const stripePayment = (url, amount) => {
    const HASH = Cookies.get('wpvc_voting_authorize');
    let dataURL = url + "wpvc-voting/v1/stripePayment";
    return dispatch => {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify({ amount: amount }),
            headers: { 'Content-Type': 'application/json', 'Authorize-wpvc': HASH, 'Authorize-wpvc-request': 'xmlhttprequest' },
        };

        return fetch(dataURL, requestOptions)
            .then(res => res.json())
            .then(json => {
                dispatch(updateFrontData('stripe_ClientSecret', json.clientSecret));
                return json;
            });
    };
};

//Apply Coupon
export const couponApply = (url, gateway, coupon, term_id) => {
    const HASH = Cookies.get('wpvc_voting_authorize');
    let dataURL = url + "wpvc-voting/v1/couponApply";
    return dispatch => {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify({ coupon: coupon, gateway: gateway, term_id: term_id }),
            headers: { 'Content-Type': 'application/json', 'Authorize-wpvc': HASH, 'Authorize-wpvc-request': 'xmlhttprequest' },
        };

        return fetch(dataURL, requestOptions)
            .then(res => res.json())
            .then(json => {
                dispatch(updateFrontData('wpvc_coupon', json));
                return json;
            });
    };
};

export const Userlogin = (url, inputdata) => {
    const HASH = Cookies.get('wpvc_voting_authorize');
    let dataURL = url + "wpvc-voting/v1/wpvclogon";
    return dispatch => {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify({ login: inputdata }),
            headers: { 'Content-Type': 'application/json', 'Authorize-wpvc': HASH, 'Authorize-wpvc-request': 'xmlhttprequest' },
        };

        return fetch(dataURL, requestOptions)
            .then(res => res.json())
            .then(json => {
                dispatch(getFrontData(json));
                return json;
            });
    };
};

//Login
export const Savenewsletter = (url, newsletter, email = null, user_id = null ) => {
    const HASH = Cookies.get('wpvc_voting_authorize');
    let dataURL = url + "wpvc-voting/v1/wpvcsavenewsletter";
    return dispatch => {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify({ newsletter: newsletter, email: email, user_id:user_id }),
            headers: { 'Content-Type': 'application/json', 'Authorize-wpvc': HASH, 'Authorize-wpvc-request': 'xmlhttprequest' },
        };

        return fetch(dataURL, requestOptions)
            .then(res => res.json())
            .then(json => {
                dispatch(getFrontData(json));
                return json;
            });
    };
};

//Logout
export const Userlogout = (url) => {
    const HASH = Cookies.get('wpvc_voting_authorize');
    let dataURL = url + "wpvc-voting/v1/wpvclogout";
    return dispatch => {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify({}),
            headers: { 'Content-Type': 'application/json', 'Authorize-wpvc': HASH, 'Authorize-wpvc-request': 'xmlhttprequest' },
        };

        return fetch(dataURL, requestOptions)
            .then(res => res.json())
            .then(json => {
                location.reload();
                dispatch(getFrontData(json));
                return json;
            });
    };
};

//User Register
export const UserRegister = (url, inputdata) => {
    const HASH = Cookies.get('wpvc_voting_authorize');
    let dataURL = url + "wpvc-voting/v1/wpvcregister";
    return dispatch => {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify({ register: inputdata }),
            headers: { 'Content-Type': 'application/json', 'Authorize-wpvc': HASH, 'Authorize-wpvc-request': 'xmlhttprequest' },
        };

        return fetch(dataURL, requestOptions)
            .then(res => res.json())
            .then(json => {
                dispatch(getFrontData(json));
                return json;
            });
    };
};

//ForgotPassword
export const ForgotPassword = (url, inputdata) => {
    const HASH = Cookies.get('wpvc_voting_authorize');
    let dataURL = url + "wpvc-voting/v1/wpvcresetpassword";
    return dispatch => {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify({ login: inputdata }),
            headers: { 'Content-Type': 'application/json', 'Authorize-wpvc': HASH, 'Authorize-wpvc-request': 'xmlhttprequest' },
        };

        return fetch(dataURL, requestOptions)
            .then(res => res.json())
            .then(json => {
                dispatch(getFrontData(json));
                return json;
            });
    };
};

//Resend verification email
export const ResendVerificationEmail = (url, inputdata) => {
    const HASH = Cookies.get('wpvc_voting_authorize');
    let dataURL = url + "wpvc-voting/v1/wpvcverificationemail";
    return dispatch => {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify({ login: inputdata }),
            headers: { 'Content-Type': 'application/json', 'Authorize-wpvc': HASH, 'Authorize-wpvc-request': 'xmlhttprequest' },
        };

        return fetch(dataURL, requestOptions)
            .then(res => res.json())
            .then(json => {
                dispatch(getFrontData(json));
                return json;
            });
    };
};

export const FacebookRegister = (url, inputdata) => {
    const HASH = Cookies.get('wpvc_voting_authorize');
    let dataURL = url + "wpvc-voting/v1/wpvcfacebooklogin";
    return dispatch => {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify({ register: inputdata }),
            headers: { 'Content-Type': 'application/json', 'Authorize-wpvc': HASH, 'Authorize-wpvc-request': 'xmlhttprequest' },
        };

        return fetch(dataURL, requestOptions)
            .then(res => res.json())
            .then(json => {
                dispatch(getFrontData(json));
                return json;
            });
    };
};

export const TwitterRegister = (url, inputdata) => {
    const HASH = Cookies.get('wpvc_voting_authorize');
    let dataURL = url + "wpvc-voting/v1/wpvctwitterlogin";
    return dispatch => {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify({ register: inputdata }),
            headers: { 'Content-Type': 'application/json', 'Authorize-wpvc': HASH, 'Authorize-wpvc-request': 'xmlhttprequest' },
        };

        return fetch(dataURL, requestOptions)
            .then(res => res.json())
            .then(json => {
                dispatch(getFrontData(json));
                return json;
            });
    };
};

export const GoogleRegister = (url, inputdata) => {
    const HASH = Cookies.get('wpvc_voting_authorize');
    let dataURL = url + "wpvc-voting/v1/wpvcgooglelogin";
    return dispatch => {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify({ register: inputdata }),
            headers: { 'Content-Type': 'application/json', 'Authorize-wpvc': HASH, 'Authorize-wpvc-request': 'xmlhttprequest' },
        };

        return fetch(dataURL, requestOptions)
            .then(res => res.json())
            .then(json => {
                dispatch(getFrontData(json));
                return json;
            });
    };
};

//GetRegister
export const GetRegister = (url) => {
    const HASH = Cookies.get('wpvc_voting_authorize');
    let dataURL = url + "wpvc-voting/v1/wpvcgetregister";
    return dispatch => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorize-wpvc': HASH, 'Authorize-wpvc-request': 'xmlhttprequest' },
        };

        return fetch(dataURL, requestOptions)
            .then(res => res.json())
            .then(json => {
                dispatch(getFrontData(json));
                return json;
            });
    };
};


//Votes
export const Savevotes = (url, post_id, cat_id, settings, post_index, email = null, voter_details = "", no_of_votes = 0, newsletter = 0) => {
    const HASH = Cookies.get('wpvc_voting_authorize');
    let dataURL = url + "wpvc-voting/v1/wpvcsavevotes";
    return dispatch => {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify({ votesetting: settings, category_id: cat_id, postid: post_id, postind: post_index, email: email, voter_details: voter_details, no_of_votes: no_of_votes, newsletter: newsletter }),
            headers: { 'Content-Type': 'application/json', 'Authorize-wpvc': HASH, 'Authorize-wpvc-request': 'xmlhttprequest' },
        };

        return fetch(dataURL, requestOptions)
            .then(res => res.json())
            .then(json => {
                dispatch(getFrontData(json));
                return json;
            });
    };
};

//Cancel Votes
export const Cancel_votes = (url, post_id, cat_id, settings, post_index, email = null) => {
    const HASH = Cookies.get('wpvc_voting_authorize');
    let dataURL = url + "wpvc-voting/v1/wpvccancelvotes";
    return dispatch => {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify({ votesetting: settings, category_id: cat_id, postid: post_id, postind: post_index, email: email }),
            headers: { 'Content-Type': 'application/json', 'Authorize-wpvc': HASH, 'Authorize-wpvc-request': 'xmlhttprequest' },
        };

        return fetch(dataURL, requestOptions)
            .then(res => res.json())
            .then(json => {
                dispatch(getFrontData(json));
                return json;
            });
    };
};

//Send Email Verification Code
export const SendEmailVerify = (url, email) => {
    const HASH = Cookies.get('wpvc_voting_authorize');
    let dataURL = url + "wpvc-voting/v1/wpvcsendemailverify";
    return dispatch => {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify({ email: email }),
            headers: { 'Content-Type': 'application/json', 'Authorize-wpvc': HASH, 'Authorize-wpvc-request': 'xmlhttprequest' },
        };

        return fetch(dataURL, requestOptions)
            .then(res => res.json())
            .then(json => {
                dispatch(getFrontData(json));
                return json;
            });
    };
};

//Captcha Verification
export const verifyCaptcha = (url, captcha) => {
    const HASH = Cookies.get('wpvc_voting_authorize');
    let dataURL = url + "wpvc-voting/v1/wpvcverifycaptcha";
    return dispatch => {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify({ captcha: captcha }),
            headers: { 'Content-Type': 'application/json', 'Authorize-wpvc': HASH, 'Authorize-wpvc-request': 'xmlhttprequest' },
        };

        return fetch(dataURL, requestOptions)
            .then(res => res.json())
            .then(json => {
                dispatch(getFrontData(json));
                return json;
            });
    };
};


//Insert submit entries
export const buyvotesPayment = (url, id, insertData) => {
    const HASH = Cookies.get('wpvc_voting_authorize');
    let dataURL = url + "wpvc-voting/v1/wpvcbuyvotesentry";
    return dispatch => {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify({ insertData: insertData, category_id: id }),
            headers: { 'Content-Type': 'application/json', 'Authorize-wpvc': HASH, 'Authorize-wpvc-request': 'xmlhttprequest' },
        };

        return fetch(dataURL, requestOptions)
            .then(res => res.json())
            .then(json => {
                dispatch(getFrontData(json));
                return json;
            });
    };
};

//Judging FrontEnd Actions
export const dataJudgeFetch = (url, termid, judge_id, post_id) => {
    const HASH = Cookies.get('wpvc_voting_authorize');
    let dataURL = url + "wpvc-voting/v2/frontend_judging";
    return dispatch => {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify({ termid: termid, judge_id: judge_id, post_id: post_id }),
            headers: { 'Content-Type': 'application/json', 'Authorize-wpvc': HASH, 'Authorize-wpvc-request': 'xmlhttprequest' },
        };

        return fetch(dataURL, requestOptions)
            .then(res => res.json())
            .then(json => {
                dispatch(getJudgeData(json));
                return json;
            });
    };
};


export const dataJudgeInsert = (url, insertData, postId, judge_id, term_id) => {
    const HASH = Cookies.get('wpvc_voting_authorize');
    let dataURL = url + "wpvc-voting/v2/frontend_judging_Insert";
    return dispatch => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorize-wpvc': HASH, 'Authorize-wpvc-request': 'xmlhttprequest' },
            body: JSON.stringify({ insertData: insertData, postId: postId, judge_id: judge_id, term_id: term_id })
        };
        return fetch(dataURL, requestOptions)
            .then(res => res.json())
            .then(json => {
                dispatch(getJudgeData(json));
                return json;
            });

    };
};

export const fetchjudgetopten = (url, term) => {  //dashboardChartdata
    const HASH = Cookies.get('wpvc_voting_authorize');
    let dataURL = url + "wpvc-voting/v2/dashboardChartdata";
    return dispatch => {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorize-wpvc': HASH, 'Authorize-wpvc-request': 'xmlhttprequest' },
            body: JSON.stringify({ term: term })
        };

        return fetch(dataURL, requestOptions)
            .then(res => res.json())
            .then(json => {
                //After Data Loading Send to Get Data to display the data respectively
                let post = { posts: json }
                dispatch(getFrontData(post));
                return json;
            });

    };
};

export const getJudgeData = results => ({
    type: 'GET_JUDGE_DATA',
    payload: results
});



export const SingleData = (id, value) => ({
    type: 'SET_SINGLE_LOAD',
    payload: {
        id: id,
        value: value,
    }
});

export const getPostLoad = (id, value) => ({
    type: 'GET_POST_LOAD',
    payload: {
        id: id,
        value: value,
    }
});

export const getFrontData = results => ({
    type: 'GET_FRONT_SETTING',
    payload: results
});

export const getFrontDataErrors = (results, errorMsg) => ({
    type: 'GET_FRONT_ERRORS',
    payload: results,
    errorMsg: errorMsg
});

export const updateFrontData = (id, value) => ({
    type: 'UPDATE_FRONT_SETTING',
    payload: {
        id: id,
        value: value,
    }
});

//Temporary draft update on immute
export const frontimmutable = (id, externalId, internalId, value) => ({
    type: 'UPDATE_FRONT_DRAFT',
    payload: {
        id: id,
        externalId: externalId,
        internalId: internalId,
        value: value,
    }
});


export const frontsingleimmute = (externalId, internalId, value) => ({
    type: 'UPDATE_SINGLE_DRAFT',
    payload: {
        externalId: externalId,
        internalId: internalId,
        value: value,
    }
});

export const frontimmute = (internalId, value) => ({
    type: 'UPDATE_DRAFT',
    payload: {
        internalId: internalId,
        value: value,
    }
});
